import React from 'react';

const Tile = (props) => {
    const {
        tileHeading,
        tileContent,
        isTileContent,
        parentClassName = "whiteCard sectionInfo",
        childClassName = "cardInfoSection"
    } = props;
    return (
        isTileContent ? <div className={parentClassName}>
            <h2>{tileHeading}</h2>
            <div className={childClassName}>
                {tileContent}
            </div>
        </div> : null
    )
}

export default Tile;
